const FormResources = {
    
    form_data: {
        building_id: '',
        name: '',
        abbreviation: '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Abbreviation:',
            model_name: 'abbreviation',
            ref:        'abbreviation_input',
            ref_alt:    'abbreviation_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   true,
            step:       '',
            name:       'Sq. Footage:',
            model_name: 'sq_ft',
            ref:        'sq_ft_input',
            ref_alt:    'sq_ft_input_alt',
            required:   false,
        },
    ]
}

export default FormResources;